import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReviewEditToggle({
  review,
  showOriginal,
  setShowOriginal
}) {
  return review.get('lastEditedAt') && review.get('original').ratings.get('OVERALL') !== review.get('ratings').get('OVERALL') ? /*#__PURE__*/_jsx(Button, {
    onClick: () => setShowOriginal(!showOriginal),
    use: "link",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-ui-reviews.edit.${showOriginal ? 'showUpdated' : 'showOriginal'}`
    })
  }) : null;
}